<script>
export default {
    name: "CancelRequestForm",

    props: {

        showModal: Boolean,
        request: Object,
    },

    methods: {

        cancelRequest() {

            this.$root.loading=true;
            this.$http.post(`MedicalFile/DeleteInvestigationRequest?PatientLabResultId=${this.request.code}&PatientId=${this.request.patientId}&VisitNo=${this.request.visitNo}&UserName=${this.$root.username}`)
                .then(response => {
                    this.$emit(`refresh`);
                    this.$root.loading=false;
                    this.$emit(`closeModal`);
                    window.Swal.fire({ type: `success`, text: response.data });
                }).catch(() => { this.$root.loading=false; this.$emit(`closeModal`); });
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-1/3 w-11/12">
  <template v-slot:title>
    <h5 class="font-medium text-base">Cancel Investigation Request</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap -m-3">
        <div class="flex-1 p-1">
           <h5 class="font-medium text-base">Request: {{ request.investigation }}</h5>
        </div>
        <div class="flex-1 p-1">
          <h5 class="font-medium text-base">Requested By: {{ request.requestedBy }}</h5>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button 
        class="btn-danger btn-sm text-xs rounded mr-6" 
        @click="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
    <button 
        @click.prevent="cancelRequest"
        class="btn-warning btn-sm text-xs rounded">
            <i class="fa fa-undo"></i> Cancel Request</button>
  </template>
</tail-modal>
</template>
